import { gql } from '@apollo/client';

import { DOCTOR_PROFILE_FRAGMENT } from './fragments';

export const GET_ME = gql`
  query Me {
    me {
      data {
        id
        first_name
        last_name
        email
        avatar
        phone
        settings
        timezone
      }
    }
  }
`;

export const GET_LANGUAGES = gql`
  query Languages($query: Pagination!) {
    languages(query: $query) {
      data {
        results {
          code
          id
          name
        }
      }
    }
  }
`;

export const GET_PAYMENT_ACCOUNT = gql`
  query PaymentAccountDoctor {
    paymentAccountDoctor {
      data {
        account_number
        bank_name
        billing_address
        created_at
        default
        doctor_id
        holder_name
        signature
        id
        updated_at
      }
    }
  }
`;

export const GET_DOCTOR_PROFILE = gql`
  query DoctorById($id: ID!, $lang: String) {
    doctorById(id: $id, lang: $lang) {
      data {
        ...DoctorProfile
      }
    }
  }
  ${DOCTOR_PROFILE_FRAGMENT}
`;
